<template>
  <div id="documentSearchTectonical">
    <main role="main">
      <div
        class="container"
        v-if="
          $globalFunctions.checkForPermission('ISCI_DOK_IN_META') &&
            $globalFunctions.checkForPermission('PREGLED_KLASIF')
        "
      >
        <div class="row mb-5">
          <div class="col-md-8">
            <h2 class="mb-3">
              <i class="fa fa-search"></i>
              {{ $t("text.documentSearch.documentSearchTectonical.title") }}
            </h2>
          </div>
          <div class="col-md-4">
            <div class="actionsContainer">
              <div class="row">
                <div class="col-12 text-right">
                  <label for="isDirectoryFlatToggleButton"
                    ><small>{{
                      $t(
                        "text.documentSearch.documentSearchTectonical.showCaseFiles"
                      )
                    }}</small></label
                  >
                  <toggle-button
                    :height="18"
                    id="isDirectoryFlatToggleButton"
                    v-model="showCaseFiles"
                    :key="showCaseFiles"
                    @change="selectItem(selectedClass, false)"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <b-breadcrumb class="mb-0">
              <b-breadcrumb-item
                v-for="(folder, index) in selectedFolderPath"
                :key="'Folder_' + index"
                :text="folder.classificationLabelName"
                :active="folder.active"
                @click="selectItem(folder, false)"
              ></b-breadcrumb-item>
            </b-breadcrumb>
          </div>

          <div class="col-md-6">
            <div class="classificationPlanDirectory">
              <loading
                :active.sync="isLoadingClassificationPlan"
                :can-cancel="false"
                :is-full-page="false"
              ></loading>

              <div
                class="classificationPlanTreeStructureContainer bg-light p-3"
              >
                <TreeStructure
                  id="treeStructure1"
                  @select-item="selectItemFromClassificationPlan"
                  :selectedClassLabel="selectedClass.classificationLabel"
                  :classificationPlan="classificationPlan"
                  :printMode="false"
                  :showPopover="true"
                  :showErrors="false"
                  :selectable="true"
                ></TreeStructure>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="selectedDirectory bg-lighter pl-3 py-3">
              <loading
                :active.sync="isLoadingDirectory"
                :can-cancel="false"
                :is-full-page="false"
              ></loading>

              <div v-if="!showCaseFiles && !isDirectoryEmpty">
                <ul class="directoryList">
                  <li
                    class="folderList"
                    v-for="folder in currentlySelectedDirectory.podrazredi"
                    @click="selectItem(folder, false)"
                  >
                    <span class="chevron-spacer"></span>
                    <span><i class="fas fa-folder"></i></span>
                    <span>
                      ({{ folder.classificationLabel }})
                      {{ folder.classificationLabelName }}</span
                    >
                  </li>

                  <li
                    class="fileList"
                    v-for="record in recordsItems"
                    @click="goToFileDescription(record.id)"
                  >
                    <span class="chevron-spacer"></span>
                    <span
                      ><i
                        :class="
                          $globalFunctions.getFileTypeIcon(record.mimetype)
                        "
                      ></i
                    ></span>
                    <span>
                      <b-badge :variant="record.deleted ? 'danger' : 'secondary'" class="px-1" v-if="record.documentStatus" v-b-tooltip :title="$globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:status_gradiva', parseInt(record.documentStatus)) + (record.deleted ? '; ' + $t('text.documentDetails.documentDeleted') : '')">{{
                          record.deleted ? 'B' : $globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:status_gradiva', parseInt(record.documentStatus)).substr(0,1)
                        }}</b-badge>
                      {{ record.title ? record.title : record.name }}
                    </span>
                  </li>
                </ul>

                <a
                  v-if="hasMoreResults"
                  @click="loadMoreItems"
                  class="btn btn-sm btn-link text-info ml-3"
                  ><i class="fa fa-download"></i
                  >{{
                    $t(
                      "text.documentSearch.documentSearchTectonical.loadMoreDocuments"
                    )
                  }}</a
                >
              </div>

              <div v-if="showCaseFiles && !isDirectoryEmpty">
                <ul class="directoryList">
                  <li
                    class="folderList"
                    v-for="folder in currentlySelectedDirectory.podrazredi"
                    @click="selectItem(folder, false)"
                  >
                    <span class="chevron-spacer"></span>
                    <span><i class="fas fa-folder"></i></span>
                    <span>
                      ({{ folder.classificationLabel }})
                      {{ folder.classificationLabelName }}</span
                    >
                  </li>

                  <li
                    class="fileList"
                    v-for="(caseFile,
                    index) in currentlySelectedDirectory.zadeve"
                    v-if="
                      currentlySelectedDirectory.zadeve &&
                        currentlySelectedDirectory.zadeve
                    "
                  >
                    <div @click="toggleIsOpenCaseFiles(index)">
                      <span>
                        <span :class="isOpenCaseFiles[index] ? 'mr-0' : 'mr-1'"
                          ><i
                            :class="
                              isOpenCaseFiles[index]
                                ? 'fas fa-chevron-down'
                                : 'fas fa-chevron-right'
                            "
                          ></i
                        ></span>
                      </span>
                      <span>
                        <i class="fas fa-book"></i>
                        {{
                          $t(
                            "text.documentSearch.documentSearchTectonical.case"
                          )
                        }}
                        {{ caseFile.opravilnaStevilka }}</span
                      >
                    </div>

                    <ul v-if="isOpenCaseFiles[index]">
                      <li
                        v-for="record in caseFile.records"
                        @click="goToFileDescription(record.id)"
                      >
                        <span
                          ><i
                            :class="
                              $globalFunctions.getFileTypeIcon(record.mimetype)
                            "
                          ></i
                        ></span>
                        <span>
                          <b-badge :variant="record.deleted ? 'danger' : 'secondary'" class="px-1" v-if="record.documentStatus" v-b-tooltip :title="$globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:status_gradiva', parseInt(record.documentStatus)) + (record.deleted ? '; ' + $t('text.documentDetails.documentDeleted') : '')">{{
                              $globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:status_gradiva', parseInt(record.documentStatus)).substr(0,1)
                            }}</b-badge>
                          {{ record.title ? record.title : record.name }}
                        </span>
                      </li>
                    </ul>
                  </li>
                </ul>

                <a
                  v-if="hasMoreResults"
                  @click="loadMoreItems"
                  class="btn btn-sm btn-link text-info ml-3"
                  ><i class="fa fa-download"></i
                  >{{
                    $t(
                      "text.documentSearch.documentSearchTectonical.loadMoreDocuments"
                    )
                  }}</a
                >
              </div>

              <div class="emptyDirectory" v-if="isDirectoryEmpty">
                {{
                  $t(
                    "text.documentSearch.documentSearchTectonical.selectedDirectoryIsEmptyError"
                  )
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script type="text/javascript">
import Vue from "vue";
import SidebarNavigation from "../components/SidebarNavigation";
import axios from "axios";
import TreeStructure from "../components/TreeStructure";
import convert from "xml-js";
import ToggleButton from "vue-js-toggle-button";
import Loading from "vue-loading-overlay";

Vue.use(ToggleButton);

export default {
  name: "DocumentSearchFullText",
  components: {
    SidebarNavigation,
    TreeStructure,
    convert,
    Loading
  },

  data() {
    return {
      sites: [],
      user: {},
      error: "",
      selectedFolderPath: [],
      classificationPlan: [],
      selectedClass: {
        classificationLabelName: this.$t(
          "text.globals.rootFolder"
        ),
        classificationLabel: "",
        alfrescoId: "-filePlan-"
      },
      currentlySelectedDirectory: {},
      recordsItems: [],
      showCaseFiles: decodeURIComponent(this.$route.query.showCaseFiles) === "true",
      isOpenCaseFiles: [],
      isLoadingClassificationPlan: false,
      isLoadingDirectory: false,
      vpisniki: [],
      povezaniSistemi: [],
      rokHrambe: [],
      vrstaGradiva: [],
      filteredVpisniki: [],
      isLoading: false,
      perPage: 20,
      totalRecords: null,
      page: 1,
      hasMoreResults: false,
      allMetadataOptions: []
    };
  },

  beforeCreate: function() {
    document.body.className = "dashboard";
  },

  mounted() {
    this.isLoadingClassificationPlan = true;

    let p1 = this.$store.dispatch("retrieveAllMetadataOptions");

    Promise.all([p1]).then((values) => {
      this.allMetadataOptions = this.$store.getters.getAllMetadataOptions;

      if(this.$route.query.classificationLabel != null && this.$route.query.classificationLabelName != null && this.$route.query.alfrescoId != null){
        if(this.$route.query.classificationLabel != "" && this.$route.query.classificationLabelName != "" && this.$route.query.alfrescoId != ""){
          let selectedClassNew =  {
            classificationLabelName: decodeURIComponent(this.$route.query.classificationLabelName),
            classificationLabel: decodeURIComponent(this.$route.query.classificationLabel),
            alfrescoId: decodeURIComponent(this.$route.query.alfrescoId),
          };

          this.selectedClass = selectedClassNew;
        }
      }

    });

    this.$store.dispatch("retrieveAllDropdownOptions").then(() => {
      this.vpisniki = this.$store.getters.getRegisterOptions;
      this.povezaniSistemi = this.$store.getters.getConnectedSystemsOptions;
      this.rokHrambe = this.$store.getters.getStorageDateOptions;
      this.vrstaGradiva = this.$store.getters.getDocumentTypeOptions;
      this.classificationPlan = this.$store.getters.getClassificationPlan;
    });

    if (
      this.$globalFunctions.checkForPermission("ISCI_DOK_IN_META") &&
      this.$globalFunctions.checkForPermission("PREGLED_KLASIF")
    ) {
      axios
        .get(config.alfrescoServiceApi + "rma/admin/ehramba/fileplan")
        .then(res => {
          let options = {
            compact: true
          };

          let classificationPlanJs = convert.xml2js(res.data, options);
            console.log("classificationPlanJs", classificationPlanJs);
          this.classificationPlan = this.formatObject(
            classificationPlanJs,
            "fromServer"
          );
          this.isLoadingClassificationPlan = false;

          console.log("SELECTED FOLDER FROM QUERY: ", this.$route.query.classificationLabelName == null);


          this.selectItem(this.selectedClass, false);

          console.log("this.classificationPlan", this.classificationPlan);


        })
        .catch(error => {
          console.error(error);
        });
    } else {
      this.$swal(
        "",
          this.$t('text.documentSearch.documentSearchTectonical.noPermissionToViewClassificationPlanSwal'),
        "info",
        { dangerMode: false }
      );
    }
  },
  computed: {
    isDirectoryEmpty() {



      if (this.showCaseFiles) {
        return !(
          (this.currentlySelectedDirectory.podrazredi && this.currentlySelectedDirectory.podrazredi.length !== 0) ||
          (this.currentlySelectedDirectory.zadeve && this.currentlySelectedDirectory.zadeve.length !== 0) ||
          (this.recordsItems && this.recordsItems.length !== 0)
        );
      } else {
        return !(
            (this.recordsItems && this.recordsItems.length !== 0) ||
            (this.currentlySelectedDirectory.podrazredi && this.currentlySelectedDirectory.podrazredi.length !== 0)
        );
      }

    }

  },
  methods: {
    loadMoreItems() {
      this.page = this.page + 1;
      this.selectItem(this.selectedClass, false, true);
    },

    selectItemFromClassificationPlan(item) {
      const _this = this;

      _this.selectItem(item, true);
    },

    selectItem(item, selectFromClassificationPlan, appendResults) {
      const _this = this;


      console.log("appendResults :", appendResults);
      console.log("_this.showCaseFiles :", _this.showCaseFiles);

      // rest pagination settings if not appending data on "load more"
      if (!appendResults) {
        _this.totalRecords = null;
        _this.page = 1;
        _this.hasMoreResults = false;
      }

      _this.isLoadingClassificationPlan = true;
      this.isLoadingDirectory = true;

      let selectedItem = {
        classificationLabel: item.classificationLabel,
        classificationLabelName: item.classificationLabelName,
        alfrescoId: item.alfrescoId,
        active: item.active
      };

      if (
        selectedItem.alfrescoId === "-filePlan-" ||
        (this.selectedClass.classificationLabel ===
          selectedItem.classificationLabel &&
          selectFromClassificationPlan)
      ) {
        this.selectedFolderPath = [];
        this.selectedFolderPath.push({
          classificationLabelName: this.$t(
            "text.globals.rootFolder"
          ),
          classificationLabel: "",
          alfrescoId: "-filePlan-",
          active: true
        });

        this.selectedClass = {
          classificationLabelName: this.$t(
            "text.globals.rootFolder"
          ),
          classificationLabel: "",
          alfrescoId: "-filePlan-"
        };
        selectedItem = {
          classificationLabelName: this.$t(
            "text.globals.rootFolder"
          ),
          classificationLabel: "",
          alfrescoId: "-filePlan-"
        };
      } else {
        this.getSelectedFolderPath(selectedItem);

        this.selectedClass = selectedItem;
      }

      console.log("item", item);
      console.log("selectedItem", selectedItem);

      let requestUrl = "";
      if (_this.showCaseFiles) {
        requestUrl = "/alfresco/s/api/rma/admin/ehramba/zadeve";
      } else {
        requestUrl = "/alfresco/s/api/rma/admin/ehramba/records";
      }

      axios
        .get(config.rootAlfresco + requestUrl, {
          params: {
            nodeId: selectedItem.alfrescoId,
            flat: !this.showCaseFiles,
            maxItems: this.perPage,
            skipCount: this.perPage * (this.page - 1)
          }
        })
        .then(res => {


          this.$router.replace({
            name: 'DocumentSearchTectonical',
            query: {classificationLabel: encodeURIComponent(selectedItem.classificationLabel),
              classificationLabelName: encodeURIComponent(selectedItem.classificationLabelName),
              alfrescoId: encodeURIComponent(selectedItem.alfrescoId),
              showCaseFiles: encodeURIComponent(_this.showCaseFiles)}
          }).catch(err => {
          });


          this.isLoadingDirectory = false;
          _this.isLoadingClassificationPlan = false;

          if (this.showCaseFiles) {
            _this.hasMoreResults = res.data.zadeve.pagination.hasMoreItems;

            if (appendResults) {
              _.each(res.data.zadeve.items, function(val) {
                _this.recordsItems.push(val);
              });

              _.each(res.data.zadeve.items, function(val) {
                if(_.find( _this.currentlySelectedDirectory.zadeve, {opravilnaStevilka: val.opravilnaStevilka})) {
                  let idx = _.findIndex(_this.currentlySelectedDirectory.zadeve,{opravilnaStevilka: val.opravilnaStevilka});
                  _this.currentlySelectedDirectory.zadeve[idx].records = [..._this.currentlySelectedDirectory.zadeve[idx].records, ...val.records];
                } else {
                  _this.currentlySelectedDirectory.zadeve.push(val);
                }
              });

              _.each(res.data.podrazredi, function(val) {
                _this.currentlySelectedDirectory.podrazredi.push(val);
              });

              _this.currentlySelectedDirectory.zadeve = _.uniqBy(
                _this.currentlySelectedDirectory.zadeve,
                "opravilnaStevilka"
              );
              _this.currentlySelectedDirectory.podrazredi = _.uniqBy(
                _this.currentlySelectedDirectory.podrazredi,
                "alfrescoId"
              );
            } else {
              _this.currentlySelectedDirectory.zadeve = res.data.zadeve.items;
              _this.currentlySelectedDirectory.podrazredi = res.data.podrazredi;

              _this.recordsItems = res.data.zadeve.items;
            }

            _this.setIsOpenCaseFiles();
          } else {
            _this.hasMoreResults = res.data.records.pagination.hasMoreItems;
            this.currentlySelectedDirectory = res.data;

            if (appendResults) {
              _.each(res.data.records.items, function(val) {
                _this.recordsItems.push(val);
              });
            } else {
              _this.recordsItems = res.data.records.items;
            }
          }

          if (_this.currentlySelectedDirectory.podrazredi.length > 0) {
            _this.currentlySelectedDirectory.podrazredi = _.sortBy(
              _this.currentlySelectedDirectory.podrazredi,
              [
                function(o) {
                  return o.classificationLabel;
                }
              ]
            );
          }
        })
        .catch(error => {
          this.isLoading = false;
          console.error(error);
        });
    },

    setIsOpenCaseFiles() {
      this.isOpenCaseFiles = [];

      if (
        !this.currentlySelectedDirectory.zadeve ||
        this.currentlySelectedDirectory.zadeve.length === 0
      ) {
        return;
      }

      for (let i = 0; i < this.currentlySelectedDirectory.zadeve.length; i++) {
        this.isOpenCaseFiles.push(true);
      }
    },

    toggleIsOpenCaseFiles(index) {
      this.isOpenCaseFiles.splice(index, 1, !this.isOpenCaseFiles[index]);
    },


    // formatira pretvorjen Klasifikacijski načrt v ustrezno strukturo, ki nam bo olajšala delo z njo
    // we adjust the classification plan structure, so it is easier to work with later
    formatObject(classificationPlanJs, typeOfImport) {
      let classificationPlanFormatted = [];

      // če je root element objekt, ga spremenimo v array
      // if the root class (root.item) is an object, we convert it to an array

      if (!classificationPlanJs.root.item) {
        return classificationPlanFormatted;
      }

      if (classificationPlanJs.root.item.length == null) {
        let itemRootArray = [];
        itemRootArray.push(classificationPlanJs.root.item);
        classificationPlanJs.root.item = itemRootArray;
      }

      if (classificationPlanJs.root.item.length > 0) {
        classificationPlanJs.root.item = _.sortBy(
          classificationPlanJs.root.item,
          [
            function(o) {
              return o.classificationLabel._text;
            }
          ]
        );
      }

      for (let i = 0; i < classificationPlanJs.root.item.length; i++) {
        let obj = this.formatObjectRec(
          classificationPlanJs.root.item[i],
          1,
          "none",
          typeOfImport
        );

        _.map(obj, function(v, k) {
          if (k == "item") {
            obj[k] = _.sortBy(v, [
              function(o) {
                return o.classificationLabel;
              }
            ]);
          }
        });
        classificationPlanFormatted.push(obj);
      }

      return classificationPlanFormatted;
    },

    formatObjectRec(
      classificationPlanJsItem,
      depth,
      parentClassLabel,
      typeOfImport
    ) {

      let formattedClass = {
        alfrescoId: null,
        classificationLabel: null,
        containsRecords: false,
        classificationLabelName: null,
        classificationLabelDescription: null,
        duplicatedClassLabels: [],
        rokHrambe: [],
        vpisnik: [],
        povezaniSistemi: [],
        usageEndDate: null,
        creationDate: null,
        parentClass: null,
        item: [],
        errors: {
          classificationLabelNameDuplicateError: null,
          classificationLabel: {
            missing: null,
            valueError: null
          },
          classificationLabelName: null,
          classificationLabelDescription: null,
          rokHrambe: {
            expirationErrors: null,

            generalExpirationError: null,
            expirationFields: []
          },
          povezaniSistemi: null,
          vpisnik: null
        },
        structure: {
          isOpen: null,
          checked: null,
          depth: null,
          changed: false,
          match: false
        }
      };

      if (typeOfImport === "fromServer") {
        formattedClass.structure.changed = false;
      } else if (typeOfImport === "fromXml") {
        formattedClass.structure.changed = true;
      }

      if (
        classificationPlanJsItem.classificationLabel &&
        classificationPlanJsItem.classificationLabel._text
      ) {
        formattedClass.classificationLabel =
          classificationPlanJsItem.classificationLabel._text;
      }

      if (
        classificationPlanJsItem.classificationLabelName &&
        classificationPlanJsItem.classificationLabelName._text
      ) {
        formattedClass.classificationLabelName =
          classificationPlanJsItem.classificationLabelName._text;
      }

      if (
        classificationPlanJsItem.classificationLabelDescription &&
        classificationPlanJsItem.classificationLabelDescription._text
      ) {
        formattedClass.classificationLabelDescription =
          classificationPlanJsItem.classificationLabelDescription._text;
      }

      if (
        classificationPlanJsItem.alfrescoId &&
        classificationPlanJsItem.alfrescoId._text
      ) {
        formattedClass.alfrescoId = classificationPlanJsItem.alfrescoId._text;
      }

      if (
        classificationPlanJsItem.containsRecords &&
        classificationPlanJsItem.containsRecords._text
      ) {
        formattedClass.containsRecords =
          classificationPlanJsItem.containsRecords._text === "true";
      }

      // for expiration we need to also go through all of the fields in a expiration entry
      if (classificationPlanJsItem.rokHrambe) {
        if (classificationPlanJsItem.rokHrambe.length == null) {
          let rokHrambeArray = [];
          rokHrambeArray.push(classificationPlanJsItem.rokHrambe);

          classificationPlanJsItem.rokHrambe = rokHrambeArray;
        }

        let rokHrambeDuplicatesCheckArray = [];

        for (let i = 0; i < classificationPlanJsItem.rokHrambe.length; i++) {
          let expirationEntry = {
            expiration: null,
            year: null,
            expirationType: null,
            isGeneral: false,
            alfrescoId: null
          };

          if (
            classificationPlanJsItem.rokHrambe[i].alfrescoId &&
            classificationPlanJsItem.rokHrambe[i].alfrescoId._text
          ) {
            expirationEntry.alfrescoId =
              classificationPlanJsItem.rokHrambe[i].alfrescoId._text;
          }

          if (
            classificationPlanJsItem.rokHrambe[i].expiration &&
            classificationPlanJsItem.rokHrambe[i].expiration._text
          ) {
            let expirationOptions = this.rokHrambe;

            let expirationErrors = true;

            for (let j = 0; j < expirationOptions.length; j++) {
              if (
                classificationPlanJsItem.rokHrambe[
                  i
                ].expiration._text.toString() ===
                expirationOptions[j].type.toString()
              ) {
                expirationErrors = false;
                break;
              }
            }

            if (!expirationErrors) {
              expirationEntry.expiration =
                classificationPlanJsItem.rokHrambe[i].expiration._text;
            }
          }

          if (
            classificationPlanJsItem.rokHrambe[i].expirationType &&
            classificationPlanJsItem.rokHrambe[i].expirationType._text
          ) {
            // let expirationTypeOptions = ['ZUP povratnica PUND','ZUP povratnica Su','ZPP povatnica PUND',
            //     'ZPP povratnica iI', 'Tožba', 'Vloga', 'Pritožba', 'Sodba'];
            //let expirationTypeOptions = this.$store.getters.getStorageDateOptions;

            let expirationTypeOptions = this.vrstaGradiva;

            let expirationTypeErrors = true;

            for (let j = 0; j < expirationTypeOptions.length; j++) {
              if (
                classificationPlanJsItem.rokHrambe[i].expirationType._text ==
                expirationTypeOptions[j].id.toString()
              ) {
                expirationTypeErrors = false;
                break;
              }
            }

            if (!expirationTypeErrors) {
              expirationEntry.expirationType =
                classificationPlanJsItem.rokHrambe[i].expirationType._text;
            }
          }

          if (
            classificationPlanJsItem.rokHrambe[i].isGeneral &&
            classificationPlanJsItem.rokHrambe[i].isGeneral._text
          ) {
            if (
              classificationPlanJsItem.rokHrambe[i].isGeneral._text === "true"
            ) {
              expirationEntry.isGeneral = true;
            } else if (
              classificationPlanJsItem.rokHrambe[i].isGeneral._text === "false"
            ) {
              expirationEntry.isGeneral = false;
            } else {
              expirationEntry.isGeneral = false;
            }
          }

          if (
            classificationPlanJsItem.rokHrambe[i].year &&
            classificationPlanJsItem.rokHrambe[i].year._text
          ) {
            expirationEntry.year =
              classificationPlanJsItem.rokHrambe[i].year._text;
          }

          if (
            !_.isEmpty(classificationPlanJsItem.rokHrambe[i]) &&
            !rokHrambeDuplicatesCheckArray.includes(
              expirationEntry.expirationType
            )
          ) {
            rokHrambeDuplicatesCheckArray.push(expirationEntry.expirationType);
            formattedClass.rokHrambe.push(expirationEntry);
          }
        }
      }

      if (classificationPlanJsItem.povezaniSistemi) {
        if (classificationPlanJsItem.povezaniSistemi.length == null) {
          let povezaniSistemiArray = [];
          povezaniSistemiArray.push(classificationPlanJsItem.povezaniSistemi);

          classificationPlanJsItem.povezaniSistemi = povezaniSistemiArray;
        }

        let povezaniSistemiDuplicatesCheckArray = [];

        for (
          let i = 0;
          i < classificationPlanJsItem.povezaniSistemi.length;
          i++
        ) {
          let povezaniSistemiOptions = this.povezaniSistemi;

          let povezaniSistemiErrors = true;

          if (
            classificationPlanJsItem.povezaniSistemi[i]._text &&
            !povezaniSistemiDuplicatesCheckArray.includes(
              classificationPlanJsItem.povezaniSistemi[i]._text
            )
          ) {
            povezaniSistemiDuplicatesCheckArray.push(
              classificationPlanJsItem.povezaniSistemi[i]._text
            );

            for (let j = 0; j < povezaniSistemiOptions.length; j++) {
              if (
                classificationPlanJsItem.povezaniSistemi[i]._text ===
                povezaniSistemiOptions[j].id.toString()
              ) {
                povezaniSistemiErrors = false;
                break;
              }
            }

            if (!povezaniSistemiErrors) {
              formattedClass.povezaniSistemi.push(
                classificationPlanJsItem.povezaniSistemi[i]._text
              );
            }
          }
        }
      }

      if (classificationPlanJsItem.vpisnik) {
        if (classificationPlanJsItem.vpisnik.length == null) {
          let vpisnikArray = [];
          vpisnikArray.push(classificationPlanJsItem.vpisnik);

          classificationPlanJsItem.vpisnik = vpisnikArray;
        }

        let vpisnikDuplicatesCheckArray = [];

        for (let i = 0; i < classificationPlanJsItem.vpisnik.length; i++) {
          this.getVpisnikiOptions(formattedClass);
          let vpisnikOptions = this.filteredVpisniki;

          let vpisnikErrors = true;

          if (
            classificationPlanJsItem.vpisnik[i]._text &&
            !vpisnikDuplicatesCheckArray.includes(
              classificationPlanJsItem.vpisnik[i]._text
            )
          ) {
            vpisnikDuplicatesCheckArray.push(
              classificationPlanJsItem.vpisnik[i]._text
            );

            for (let j = 0; j < vpisnikOptions.length; j++) {
              if (
                classificationPlanJsItem.vpisnik[i]._text ===
                  vpisnikOptions[j].id.toString() &&
                _.includes(
                  formattedClass.povezaniSistemi,
                  vpisnikOptions[j].connectedSystem
                )
              ) {
                vpisnikErrors = false;
                break;
              }
            }
            if (!vpisnikErrors) {
              formattedClass.vpisnik.push(
                classificationPlanJsItem.vpisnik[i]._text
              );
            }
          }
        }
      }

      // we check if the imported dates are valid (if not, we remove them)

      if (
        classificationPlanJsItem.usageEndDate &&
        classificationPlanJsItem.usageEndDate._text
      ) {
        let usageEndDateMoment = this.moment(
          classificationPlanJsItem.usageEndDate._text,
          "DD-MM-YYYY"
        );

        if (usageEndDateMoment.isValid()) {
          formattedClass.usageEndDate =
            classificationPlanJsItem.usageEndDate._text;
        }
      }

      // i think that we should ignore/throw out the parentClass tag, because it is easily set when importing the plan
      /*
                if(classificationPlanJsItem.parentClass && classificationPlanJsItem.parentClass._text) {
                    formattedClass.parentClass = classificationPlanJsItem.parentClass._text;
                }
                */

      // we set the parent class because it is useful to have it for moving, adding new classes ...
      formattedClass.parentClass = parentClassLabel;

      //the  first two levels of the classification plan should be opened when we import the plan

      formattedClass.structure.isOpen = depth === 1 || depth === 2;
      formattedClass.structure.depth = depth;
      formattedClass.structure.checked = true;

      if (typeOfImport === "fromServer") {
        if (
          classificationPlanJsItem.creationDate &&
          classificationPlanJsItem.creationDate._text
        ) {
          formattedClass.creationDate =
            classificationPlanJsItem.creationDate._text;
        }
      } else {
        // creation date attribute is added
        console.log(" // creation date attribute is added  // creation date attribute is added  // creation date attribute is added");
        let today = new Date();
        let dd = String(today.getDate()).padStart(2, "0");
        let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        let yyyy = today.getFullYear();
        today = dd + "-" + mm + "-" + yyyy;

        formattedClass.creationDate = today;
      }

      // if there is no children we put an empty array

      if (!classificationPlanJsItem.item) {
        classificationPlanJsItem.item = [];
      }

      // if there is only one child, the parser interprets it as an object, so we need to convert it to an array
      else if (classificationPlanJsItem.item.length == null) {
        let itemArray = [];
        itemArray.push(classificationPlanJsItem.item);
        classificationPlanJsItem.item = itemArray;
      }

      //finally, we recursively call the function on all the children

      for (let i = 0; i < classificationPlanJsItem.item.length; i++) {
        formattedClass.item.push(
          this.formatObjectRec(
            classificationPlanJsItem.item[i],
            depth + 1,
            formattedClass.classificationLabel,
            typeOfImport
          )
        );
      }

      return formattedClass;
    },

    getVpisnikiOptions(classificationPlan) {
      let filteredVpisniki = [];

      _.forEach(this.vpisniki, function(value, key) {
        if (
          _.includes(classificationPlan.povezaniSistemi, value.connectedSystem)
        ) {
          filteredVpisniki.push(value);
        }
      });

      this.filteredVpisniki = filteredVpisniki;
    },

    getSelectedFolderPath(item) {
      let currentPath = [];
      this.selectedFolderPath = [];

      currentPath.push({
        classificationLabelName: this.$t(
          "text.globals.rootFolder"
        ),
        classificationLabel: "",
        alfrescoId: "-filePlan-",
        active: false
      });

      for (let i = 0; i < this.classificationPlan.length; i++) {
        let possiblePath = this.getSelectedFolderPathRec(
          item,
          this.classificationPlan[i],
          [...currentPath]
        );

        if (possiblePath != null) {
          currentPath = possiblePath;
        }
      }

      this.selectedFolderPath = this.selectedFolderPath.concat(currentPath);
    },
    getSelectedFolderPathRec(item, currentClass, currentPath) {
      if (currentClass.classificationLabel === item.classificationLabel) {
        currentPath.push({
          classificationLabelName: currentClass.classificationLabelName,
          classificationLabel: currentClass.classificationLabel,
          alfrescoId: currentClass.alfrescoId,
          active: true
        });

        return currentPath;
      } else {
        currentPath.push({
          classificationLabelName: currentClass.classificationLabelName,
          classificationLabel: currentClass.classificationLabel,
          alfrescoId: currentClass.alfrescoId,
          active: false
        });

        for (let i = 0; i < currentClass.item.length; i++) {
          let possiblePath = this.getSelectedFolderPathRec(
            item,
            currentClass.item[i],
            [...currentPath]
          );

          if (possiblePath != null) {
            return possiblePath;
          }
        }

        return null;
      }
    },

    goToFileDescription(fileId) {

      let documentPath = "/dokument/" + fileId;
      this.$router.push({ path: documentPath });

    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/DocumentSearchTectonical.vue